
$(document).ready(function() {
  "use strict";  
  responsiveResize();
  footerCollapse1();
});

// function footerCollapse()
// {
//     $('.mobile-collapse_title').on('click', function(e){
//       e.stopPropagation();
//       $(this).toggleClass('active').parent().find('.mobile-collapse_content').stop().slideToggle('medium');
//       e.preventDefault();
//     })
//     $('.mobile-collapse_title').find('.mobile-collapse_content').slideUp('medium');
//   }


function accordionFooter(status)
  {
    if(status == 'enable')
    {
     $('.mobile-collapse_title').on('click', function(e){
      e.stopPropagation();
      $(this).toggleClass('active').parent().find('.mobile-collapse_content').stop().slideToggle('medium');
      e.preventDefault();
    })
     $('.mobile-collapse_title').find('.mobile-collapse_content').slideUp('medium');
   }
   else
   {
    $('.mobile-collapse_content').removeClass('active').off().parent().find('.mobile-collapse_content').removeAttr('style').slideDown('medium');
    // $('#footer').removeClass('accordion');
  }
}

function responsiveResize()
{
        if ($(window).width() <= 991 ) {
                // accordion('enable');
                accordionFooter('enable');
        } else if ($(window).width() >= 992) {
                // accordion('disable');
                accordionFooter('disable');
        }
}

function footerCollapse1()
{
  $('.Filter-inner-block .rv-downi').on('click', function(e){
    e.stopPropagation();
    $(this).toggleClass('active').parent().find('.level1').stop().slideToggle('medium');
    e.preventDefault();
  })
  $('.Filter-inner-block .rv-downi').find('.level1').slideUp('medium');
}

$(document)
.on('shopify:section:load', eventHandler)
.ready(function() { $('[data-sectionname]').each(function(){ $(this).initSection() }); });

function eventHandler(e) {
  $('#' + e.target.id).find('[data-sectionname]').initSection();
}
$.fn.initSection = function(){
  var _ = this;
  var n = _.data('sectionname');
  switch (n) {
    case ("Product-tab-view"): _.find('.product-grid-slider').initSlick_product(); break;
    case ("bottom_blog"): _.find('.rvsmartblog-carousel').initSlick_bmblog(); break;
    case ("slider_withbanners"): _.find('.slick-slider-content').dotSlick(); break;
    default: break;
  }
}

$.fn.initSlick_bmblog = function() {
  this.slick({
    arrows:false,
    prevArrow: '<div class="arrow-slick"><div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div></div>',
    nextArrow: '<div class="arrow-slick"><div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div></div>',
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
  });
}

$.fn.initSlick_product = function() {
  this.slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   arrows: false,
   dots: false,
   rows: 2,
   fade: false,
   prevArrow: '<i class="fa fa-angle-left"></i>',
   nextArrow: '<i class="fa fa-angle-right"></i>',
   pauseOnHover: true,
     responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }, 
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }]
  });
}

$.fn.initSlick = function(md, sm, xs) {
  this.slick({
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
  });
}

$.fn.dotSlick = function(){
  this.slick({
    infinite: true,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<i class="fa fa-angle-left"></i>',
    nextArrow: '<i class="fa fa-angle-right"></i>',
  });
}




